module.exports = __webpack_public_path__ + "static/media/icon-criador.62710efb.svg";